<script>
  const API_URL = process.env.API_SERVER_URL
  const CDN_URL = process.env.CDN_URL

  export default {
    urls: {
      foobar: API_URL + '/foobar/',

      foobar_add_tag: API_URL + '/foobar/{foobar_id}/tag/{tag}',

      foobar_manage_photo: API_URL + '/foobar/{foobar_id}/attachment/',
      foobar_manage_tag: API_URL + '/foobar/{foobar_id}/tag/',

      foobar_update_dependency: API_URL + '/foobar/{foobar_id}/dependency/',
      foobar_update_description: API_URL + '/foobar/{foobar_id}/description/',
      foobar_update_output: API_URL + '/foobar/{foobar_id}/output/',
      foobar_update_snippet: API_URL + '/foobar/{foobar_id}/snippet/',
      foobar_update_snippet_title: API_URL + '/foobar/{foobar_id}/snippet/{snippet_id}/title/',
      foobar_update_snippet_content: API_URL + '/foobar/{foobar_id}/snippet/{snippet_id}/content/',
      foobar_update_snippet_lang: API_URL + '/foobar/{foobar_id}/snippet/{snippet_id}/lang/',
      foobar_update_snippet_order: API_URL + '/foobar/{foobar_id}/snippet-order/',
      foobar_update_status: API_URL + '/foobar/{foobar_id}/status/',
      foobar_update_md: API_URL + '/foobar/{foobar_id}/md/',
      foobar_update_title: API_URL + '/foobar/{foobar_id}/title/',

      foobar_delete_snippet: API_URL + '/foobar/{foobar_id}/snippet/{snippet_id}/',

      foobar_news: API_URL + '/foobar/status/news',
      search: API_URL + '/foobar/search/',

      image_url: CDN_URL + '/{foobar_id}/{file_name}'
    }
  }
</script>



// WEBPACK FOOTER //
// Config.vue?2e267055